module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_4.848b259d.pdf";